import { useEffect, useState } from 'react';
import { usePrefersReducedMotion } from '../../hooks/usePrefersReducedMotion';
import { ACCENT, BORDER, EASE_SPRING, FONT_MONO, MUTED, TEXT_PRIMARY } from '../../tokens';

interface ShuffleItem {
  stat: string;
  sub: string;
}

const SHUFFLE_ITEMS: readonly ShuffleItem[] = [
  { stat: '5 / week', sub: 'LinkedIn, text and image' },
  { stat: '5 / week', sub: 'Instagram and Facebook, carousels and job footage' },
  { stat: '43 / month', sub: 'Published across every channel' },
];

/** Auto-cycling stacked stat cards. The rear card rotates to the front every 3s. */
export function ShufflerCard() {
  const reduced = usePrefersReducedMotion();
  const [stack, setStack] = useState<readonly ShuffleItem[]>(SHUFFLE_ITEMS);

  useEffect(() => {
    if (reduced) return;

    const timer = setInterval(() => {
      setStack((current) => {
        const next = [...current];
        const last = next.pop();
        if (last) next.unshift(last);
        return next;
      });
    }, 3000);

    return () => clearInterval(timer);
  }, [reduced]);

  return (
    <div style={{ position: 'relative', minHeight: 148, marginTop: 8 }}>
      {stack.map((item, i) => (
        <div
          key={item.sub}
          style={{
            position: 'absolute',
            inset: 0,
            top: i * 11,
            left: i * 7,
            right: -i * 7,
            zIndex: 3 - i,
            opacity: 1 - i * 0.28,
            transform: `scale(${1 - i * 0.04})`,
            transition: `all 0.65s ${EASE_SPRING}`,
            background: i === 0 ? '#181818' : '#141414',
            border: `1px solid ${i === 0 ? 'rgba(255,107,0,0.28)' : BORDER}`,
            borderRadius: 16,
            padding: '18px 20px',
          }}
        >
          <div style={{ fontFamily: FONT_MONO, fontSize: '0.62rem', color: ACCENT, letterSpacing: '0.1em', marginBottom: 10 }}>
            PUBLISHING CADENCE
          </div>
          <div style={{ fontSize: '1.9rem', fontWeight: 800, lineHeight: 1, color: TEXT_PRIMARY }}>{item.stat}</div>
          <div style={{ fontSize: '0.8rem', color: MUTED, marginTop: 6 }}>{item.sub}</div>
        </div>
      ))}
    </div>
  );
}
